export function maskSsn(taxId: string): string {
  if (!taxId) return ''
  return taxId.replace(/\d/g, '•')
}
